import Profile from '@/components/Profile/Profile.vue';
import Share from '@/components/Profile/Share/Share.vue';
import Vop from '@/components/Profile/Vop/Vop.vue';
import Form from '@/components/Profile/Form/Form.vue';
import Portfolio from '@/components/Profile/Portfolio/Portfolio.vue';
import PortfolioIntro from '@/components/Profile/Portfolio/PortfolioIntro.vue';
import Gallery from '@/components/Profile/Gallery/Gallery.vue';
import Winlist from '@/components/Profile/Ratings/Winlist.vue';
import Shortlist from '@/components/Profile/Ratings/Shortlist.vue';
import Contracts from '@/components/Profile/Contracts/Contracts.vue';
import VideoGallery from '@/components/Profile/Video/Gallery/VideoGallery.vue';
import VideoProjects from '@/components/Profile/Video/Projects/VideoProjects.vue';

export default [
    {
        path: '/profile',
        component: Profile,
        children: [
            {
                name: 'profile-intro',
                path: '',
                component: PortfolioIntro,
                meta: { detail: false, menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-share',
                path: 'share',
                component: Share,
                meta: { closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-voice',
                path: 'my-voice',
                component: Portfolio,
                meta: {
                    accessibleByToken: true,
                    closeButtonBackLink: '/profile',
                    menuSection: 'profile',
                    impersonateAble: true,
                },
            },
            {
                name: 'profile-edit',
                path: 'my-data',
                component: Form,
                meta: { closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-face',
                path: 'my-face',
                component: Gallery,
                meta: { closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-video',
                path: 'my-video',
                component: VideoGallery,
                meta: { closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-projects',
                path: 'my-projects',
                component: VideoProjects,
                meta: { closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-winlist',
                path: 'winning-rating-list',
                component: Winlist,
                meta: { public: true, closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-shortlist',
                path: 'shortlist-rating',
                component: Shortlist,
                meta: { public: true, closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-contracts',
                path: 'my-contracts',
                component: Contracts,

                children: [
                    {
                        name: 'profile-contracts-detail',
                        path: ':id(\\d+)',
                        component: Contracts,
                        meta: { closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
                    },
                ],
                meta: { closeButtonBackLink: '/profile', menuSection: 'profile', impersonateAble: true },
            },
            {
                name: 'profile-vop',
                path: 'vop',
                component: Vop,
                meta: { avoidTerms: true, menuSection: 'profile', impersonateAble: true },
            },
        ],
    },
];
